export interface IAnyBuildConfigByVite {
    alias: any,
    define?: any,
    componentsDir?: string, //组件文件夹
    glob?: {
        componentsDir?: string // 组件文件夹匹配模式
        componentsDir_ignore?: string[] // 组件文件夹不匹配的模式
    },
    vite?: import("vite").InlineConfig
}

// overide是否覆盖整个内置的tsup配置
export type IAnyBuildConfigByTsup = { overide?: boolean } & import("tsup").Options

export enum EDefineConfig {
    VITE = "vite",
    TSUP = "tsup"
}
export type IAnyBuildConfig<T extends EDefineConfig> = T extends EDefineConfig.VITE ? IAnyBuildConfigByVite : T extends EDefineConfig.TSUP ? IAnyBuildConfigByTsup : any

export function defineConfig<T extends EDefineConfig>(config: IAnyBuildConfig<T>) {
    return config
}